/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";
import { ReactComponent as DocumentIcon } from '../../../resources/images/slash-icon.svg';

/* Styles */
import styles from "./styles";

const DeclineModal = ({showModal, setShowModal, submitCallback, tierName}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleConfirmModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ <DocumentIcon /> }
      modalTitle={ <FormattedMessage id="declineModal.title" /> }
      modalDescription={ <FormattedMessage id="declineModal.description" values={{tier: tierName}}/> }
      modalFooter={ <Footer setShowModal={setShowModal} handleConfirmModal={handleConfirmModal}/> }
      dataTestId="declinemodal"
      hideCloseButton={true}
      // keepOnBackdrop={true}
    />
  )
}

export default DeclineModal;
